module.exports = __webpack_public_path__ + "img/liveTitle1.c9d00d60.png";